// extracted by mini-css-extract-plugin
export default {"appLayoutWrapper":"AppLayout_appLayoutWrapper__-llLA","title":"AppLayout_title__XvHyR","image":"AppLayout_image__bY0CE","icon":"AppLayout_icon__arywi"};